module.exports = __webpack_public_path__ + "img/1555093328881631233.f1b78c8b.jpg";